import { resolverCondicao } from "@/shared/components";
import type {
  FinanceiroCondicaoProps,
  FinanceiroCondicaoViewModel,
} from "./types-financeiro-condicao";

/** Resolve a condição (texto livre do core) no rótulo e no destaque de obra em seco. */
export function useFinanceiroCondicao({
  condicao,
  testId,
}: FinanceiroCondicaoProps): FinanceiroCondicaoViewModel {
  const resolved = resolverCondicao(condicao);

  return {
    isEmpty: resolved === null,
    label: resolved?.label ?? "",
    seco: resolved?.seco ?? false,
    known: resolved?.known ?? false,
    testId,
  };
}
